module.exports = __webpack_public_path__ + "img/address.bd7cc971.svg";